import { z } from "zod";
import { FieldBaseSchema, defineControl } from "./field.js";
// The browser's own date input draws its own empty state, so there is no
// placeholder to give it. A value is the date as the input reports it,
// YYYY-MM-DD, with no time and no zone. An empty one is no answer, never "".
export const datePicker = defineControl({
    key: "datePicker",
    label: "Date picker",
    schema: FieldBaseSchema.extend({ control: z.literal("datePicker") }),
    answer: z.iso.date(),
    isClearable: true,
    empty: { required: false },
});
